import { Storage } from './../../service/';
import { set, get } from 'lodash/fp';
import { createReducer } from './../../service/Utils';
import doRecursive from '../../utils/recursive';
import { settingsMenu } from '../../service/Config/data';
import { hasSomeAccess } from '../../service/AccessMerchant';

const getInitialState = ({ stateName = '', defaultState = false }) => {
  const fromLocalStorage = Storage.loadStateData() && Storage.loadStateData()[stateName];
  if (fromLocalStorage) return fromLocalStorage;
  return defaultState;
};

const getActiveSettingsNavItem = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const path = window.atob(queryParams.get('open_url') || '') || window.location.pathname;

  return doRecursive('children')(settingsMenu(hasSomeAccess)).find(({ router }) =>
    path.startsWith(router)
  );
};

const initialState = {
  sidebarTab: getActiveSettingsNavItem() ? 'settings' : 'home',
  isFullModeMenu: getInitialState({ stateName: 'isFullModeMenu', defaultState: true }),
  selectedAccount: '',
  selectedDataRow: null,
  isShowFormLogout: false,
  isShowFormAccount: false,
  isLoadingAccount: false,
  mobileMenuVisible: false,
  customBreadcrumb: {},
  userTimer: 0,
  isGhostTestMode: getInitialState({ stateName: 'isGhostTestMode', defaultState: false })
};

export default createReducer(initialState, {
  CHANGE_MODE_MENU: (state) => {
    const isFullModeMenu = !state.isFullModeMenu;
    Storage.saveStateData({ isFullModeMenu: !isFullModeMenu });
    return { ...state, isFullModeMenu };
  },
  SELECTED_ACCOUNT: (state, payload) => {
    const selectedAccount = state.selectedAccount;
    const currentFilterData = Storage.getDataByKey('filter');
    const newFilterData =
      selectedAccount && currentFilterData
        ? Object.keys(currentFilterData).reduce((result, key) => {
            const { page, count, ...rest } = currentFilterData[key];
            result[key] = { ...rest };
            return result;
          }, {})
        : null;
    Storage.saveStateData({
      merchant: payload,
      ...(newFilterData && { filter: newFilterData })
    });
    return { ...state, selectedAccount: payload };
  },
  SHOW_POPUP_FORM: (state, payload) => {
    return set(`isShowForm${payload}`, !get(`isShowForm${payload}`, state), state);
  },
  CLOSE_POPUP_FORM: (state, payload) => {
    return set(`isShowForm${payload}`, false, state);
  },
  SHOW_RELOGIN_FORM: (state, payload) => {
    return { ...state, isShowFormReLogin: payload };
  },
  SELECTED_ROW_DATA: (state, payload) => {
    return { ...state, selectedDataRow: payload };
  },
  SET_STATE_DATA: (state, payload) => {
    return set(payload[0], payload[1], state);
  },
  SET_STATEMENT_DATA: (state, payload) => {
    return { ...state, statement: payload };
  },
  SET_CUSTOM_BREADCRUMB: (state, payload) => {
    return { ...state, customBreadcrumb: payload };
  },
  USER_TIMER: (state, payload) => {
    return { ...state, userTimer: payload };
  },
  TIMER_START: (state) => {
    return { ...state, userTimer: 0 };
  },
  SET_GHOST_USER_MODE: (state, payload) => {
    Storage.saveStateData({ isGhostTestMode: payload });
    return { ...state, isGhostTestMode: payload };
  },
  SET_SIDEBAR_TAB: (state, payload) => {
    return { ...state, sidebarTab: payload };
  },
  SET_MOBILE_MENU_VISIBLE: (state, payload) => {
    return { ...state, mobileMenuVisible: payload };
  }
});
